export function isLoged(){
    const token = window.localStorage.getItem('token');
    if(token && token !== 'undefined') {
        return true;
    }
    return false;
}

export function getTokenCredentials () {
    const token = window.localStorage.getItem('token');
    return btoa(token+":")
}

// Validadores compartidos. Los datos de personas/multas provienen de la app
// móvil (syncapk) y suelen llegar con espacios o saltos de línea alrededor; el
// regex anclado (^...$) rechazaría un valor por lo demás válido si no se recorta
// antes. Siempre recortar primero.
export function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email ?? '').trim());
}

export function isValidPhone(phone) {
    return /^\d{7,15}$/.test(String(phone ?? '').trim());
}

// ---------------------------------------------------------------------------
// Helpers de pago. Una multa (headerFine) puede tener uno o varios conceptos
// (detailFine[]). El backend espera un registro por concepto con el saldo
// restante de la multa (remainder) y `amount` con el total reportado.
// ---------------------------------------------------------------------------

export function round2(value) {
    const n = parseFloat(value);
    if (!Number.isFinite(n)) return 0;
    return Math.round((n + Number.EPSILON) * 100) / 100;
}

// Suma de saldos de un conjunto de multas, redondeada a centavos.
export function sumRemainder(fines) {
    return round2((fines || []).reduce((total, fine) => total + (parseFloat(fine?.remainder) || 0), 0));
}

// Construye el arreglo detailFine para el pago: un registro por concepto de
// cada multa seleccionada, con el saldo restante de la multa (`remainder`, la
// columna "Restante") tal cual se muestra. El backend aplica el pago.
export function buildDetailFinePayload(fines) {
    return (fines || []).flatMap((fine) => {
        const amount = round2(fine?.remainder);
        return (fine?.detailFine || [])
            .filter((d) => d && d.idDetail !== undefined && d.idDetail !== null)
            .map((d) => ({ idDetailFine: Number(d.idDetail), amount }));
    });
}

// Todos los ids de concepto (para api/payment/admin/pd, que recibe []int64).
export function collectDetailIds(fines) {
    return (fines || []).flatMap((fine) =>
        (fine?.detailFine || [])
            .filter((d) => d && d.idDetail !== undefined && d.idDetail !== null)
            .map((d) => Number(d.idDetail))
            .filter((v) => Number.isFinite(v))
    );
}

// Sincroniza la selección con la lista recién cargada: descarta multas que ya
// no están o ya no son pagables y reemplaza cada objeto por su versión fresca.
export function refreshSelection(selected, fines) {
    const byId = new Map((fines || []).map((f) => [f.idHeaderFine, f]));
    return (selected || [])
        .map((s) => byId.get(s.idHeaderFine))
        .filter((f) => f && f.isCheckbox);
}

// ---------------------------------------------------------------------------
// Permisos de grupos. El backend desplegado rechaza cualquier cadena JSON que
// contenga comillas dobles (responde -101 "Error seteando los Datos") y además
// elimina las comillas simples antes de guardar. Como `permissions` es un JSON
// serializado, para crear y editar grupos sin tocar el backend se envía sin
// comillas (`[{rules:[{name:see,value:true}]}]`, que es exactamente lo que queda
// en la base) y al leer se restauran. Las claves y valores de texto son siempre
// identificadores (módulo, nombre de permiso), y los valores booleanos quedan
// intactos. Los permisos ya guardados como JSON válido se aceptan tal cual.
// ---------------------------------------------------------------------------

export function encodePermissions(json) {
    return String(json ?? '').replace(/["']/g, '');
}

export function decodePermissions(raw) {
    const value = String(raw ?? '');
    if (!value || value.includes('"')) return value;
    return value
        .replace(/'/g, '')
        // Claves: `{rules:` → `{"rules":`
        .replace(/([{,[])\s*([A-Za-z_]\w*)\s*:/g, '$1"$2":')
        // Valores de texto: `:see,` → `:"see",` (true/false/null se respetan)
        .replace(/:\s*([A-Za-z_]\w*)\s*(?=[,}\]])/g, (match, word) =>
            ['true', 'false', 'null'].includes(word) ? `:${word}` : `:"${word}"`);
}

export function parsePermissions(raw) {
    const json = decodePermissions(raw);
    if (!json) return [];
    try {
        const parsed = JSON.parse(json);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}
